import React, { FC }               from 'react';
import { useQuery }                from '@apollo/react-hooks';
import { QueriedSelectFieldProps } from '../formik';

import { CorvalTag }                       from '@src/types';
import { formatOption, IFormatOptions }    from '@src/util';
import { DecisionEngineQueries }           from '@src/queries';
import { queriesHaveData, queriesLoading } from '@src/store/_apolloUtil';
import { SelectField }                     from '@src/views/components/forms';


interface MetaTagDropdownProps extends QueriedSelectFieldProps {
    loading?: boolean,
    formatOptions?: IFormatOptions,
}

const defaultProps: MetaTagDropdownProps = {
    loading:       false,
    formatOptions: {},
};

const MetaTagDropdown: FC<MetaTagDropdownProps> = ( _props ) => {

    let { formatOptions, ...props } = _props;

    let getTagsReq = useQuery(
        DecisionEngineQueries.queries.GET_META_TAGS(), {
            variables:   { order: [ { name: 'ASC' } ] },
            fetchPolicy: 'network-only',
        } );

    let isLoading = ( props.loading || queriesLoading( getTagsReq ) );

    let options = queriesHaveData( getTagsReq ) ?
                  getTagsReq.data.tags.map( ( tag: CorvalTag ) => {

                      return formatOption(
                          tag.name,
                          tag.name,
                          { group: tag.name.substring( 0, 1 ), ...formatOptions }
                      );

                  } ) : [];

    return (
        <SelectField
            useGroupNames={ true }
            loading={ isLoading }
            options={ options }
            { ...props }
        />
    );
};

MetaTagDropdown.defaultProps = defaultProps;

export { MetaTagDropdown };
